import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPostDownload } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const reportExport = createAsyncThunk(
  "reportExport",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await doPostDownload(urls?.reportExport, arg);

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const reportExportSlice = createSlice({
  name: "reportExport",
  initialState: {
    isLoading: false,
    success: false,
    data: false,
    error: null,
  },
  reducers: {
    reportExportReset: () => {
      return {
        isLoading: false,
        success: false,
        data: false,
        error: null,
      };
    },
  },
  extraReducers: {
    [reportExport.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.success = true;
      state.data = payload;
      state.error = null;
    },
    [reportExport.pending]: (state) => {
      state.isLoading = true;
      state.success = false;
      state.data = false;
    },
    [reportExport.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.data = false;
      state.error = payload;
    },
  },
});

export const { reportExportReset } = reportExportSlice.actions;
